import type { FC } from 'react';
import React from 'react';

import { Box } from '@mui/material';
import { bindPopover, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';

import { SidebarAddItemsPopoverStyle } from '@shared/ui/popovers/SidebarAddItemsPopover/SidebarAddItemsPopover.style';
import SidebarAddItemsPopoverList from '@shared/ui/popovers/SidebarAddItemsPopover/components/SidebarAddItemsPopoverList';

type SidebarAddItemsPopoverProps = {
  children: React.ReactNode;
  anchorOriginVertical?: 'bottom' | 'top' | 'center';
  anchorOriginHorizontal?: 'center' | 'right' | 'left';
  transformOriginVertical?: 'bottom' | 'top' | 'center';
  transformOriginHorizontal?: 'center' | 'right' | 'left';
};
const SidebarAddItemsPopover: FC<SidebarAddItemsPopoverProps> = ({
  children,
  anchorOriginHorizontal = 'right',
  anchorOriginVertical = 'center',
  transformOriginHorizontal = 'left',
  transformOriginVertical = 'center',
}) => {
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'sidebarAddItemPopover',
  });

  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <Box
        sx={{ display: 'inline-block', cursor: 'pointer' }}
        {...bindTrigger(popupState)}
        id="sidebarAddItemPopover"
      >
        {children}
      </Box>
      <SidebarAddItemsPopoverStyle
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: anchorOriginVertical,
          horizontal: anchorOriginHorizontal,
        }}
        transformOrigin={{
          vertical: transformOriginVertical,
          horizontal: transformOriginHorizontal,
        }}
        classes={{
          paper: 'onboarding-checklists-popover-container',
        }}
      >
        <Box>
          <SidebarAddItemsPopoverList onClose={() => popupState.close()} />
        </Box>
      </SidebarAddItemsPopoverStyle>
    </Box>
  );
};

export default SidebarAddItemsPopover;
